import * as React from 'react'
// libs
import { useLocation, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { Themes, useTheme } from '../../../hooks/useTheme'

const ScrollHandler = () => {
  const navigate = useNavigate()
  const { hash, pathname } = useLocation()
  const [showOverlay, setShowOverlay] = React.useState(false)

  const isMobile = matchMedia('(hover: none) and (pointer: coarse)').matches
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

  const { theme } = useTheme()

  const isLightTheme = theme === Themes.LIGHT

  const scrollOverlayClassNames = classNames('auto-scroll-overlay', {
    'light-theme': isLightTheme,
  })

  React.useLayoutEffect(() => {
    if (!hash) {
      return
    }

    const element = document.querySelector(hash)

    if (!element) {
      return
    }

    if (isMobile || isSafari) {
      setShowOverlay(true)

      setTimeout(() => {
        element.scrollIntoView({
          behavior: 'auto',
          block: 'start',
        })
      }, 200)

      setTimeout(() => {
        setShowOverlay(false)

        navigate(pathname, {
          replace: true,
          preventScrollReset: true,
        })
      }, 200)
    } else {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
      navigate(pathname, {
        replace: true,
        preventScrollReset: true,
      })
    }
  }, [hash])

  React.useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    }
  }, [pathname])

  return showOverlay ? <div className={scrollOverlayClassNames} /> : null
}

export default ScrollHandler
